import React, { useState } from "react";
import { Box, Button, List, Popover, Popper, Stack, ListItem, ListItemIcon } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'next-share';

import TransparentButton from "../global/TransparentButton";
import { colours } from "../../constants/colourConstants";
import { css } from "glamor";


const socialPlatforms = [
    {
        name: "Facebook",
        icon: FacebookIcon,
        button: FacebookShareButton,
    }, {
        name: "Twitter",
        icon: TwitterIcon,
        button: TwitterShareButton,
    }, {
        name: "LinkedIn",
        icon: LinkedInIcon,
        button: LinkedinShareButton,
    }
]


const BlogSocialShare = ({ pageUrl }) => {
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "share-menu" : undefined

    return (
        <Box>
            <TransparentButton
                handleClick={handleClick}
                type="button" //should set on button components
                ariaDescribedBy={id}
                {...css({
                    color: colours.primary.greys[700]
                })}
            >
                Share
            </TransparentButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                onClose={handleClose}
            >
                <List
                    dense
                    sx={{
                        backgroundColor: colours.white,
                        border: `${colours.primary.greys[200]} solid 1px`,
                        borderRadius: "4px",
                        width: "160px"
                    }}
                >
                    {socialPlatforms.map(item => (
                        <ListItem
                            disablePadding
                            sx={{
                                marginBottom: 0,
                                "&:hover": {
                                    backgroundColor: colours.primary.greys.hover,
                                }
                            }}
                        >
                            <item.button
                                style={{
                                    width: "100%",
                                    padding: "8px 12px",
                                }}
                                url={pageUrl}
                                blankTarget={true}
                            >
                                <Stack direction="row" spacing={2}>
                                    <ListItemIcon sx={{ minWidth: "24px", marginRight: "12px" }}>
                                        <item.icon />
                                    </ListItemIcon>
                                    {item.name}
                                </Stack>
                            </item.button>
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </Box >
    )
}

export default BlogSocialShare